import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-pdpm-calculator',
  templateUrl: './pdpm-calculator.component.html',
  styleUrls: ['./pdpm-calculator.component.scss']
})
export class PdpmCalculatorComponent implements OnInit {
  pdpmForm: FormGroup;
  calculatedScore: number | null = null;
  spinner: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MatDialogRef<PdpmCalculatorComponent>,
    private toastr: ToastrService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pdpmForm = this.formBuilder.group({
      patientName: [''],
      age: [''],
      diagnosis: [''],
      assessmentDate: [''],
      category: ['']
    });
  }

  ngOnInit(): void { }

  calculatePDPM(): void {
    if (this.pdpmForm.invalid) {
      this.toastr.warning('Please fill all required fields', '', { timeOut: 2000 });
      return;
    }

    this.spinner = true;
    const formValue = this.pdpmForm.value;

    this.calculatedScore =
      (formValue.age ? parseInt(formValue.age, 10) : 0) +
      (formValue.category ? formValue.category.length : 0);

    setTimeout(() => {
      this.spinner = false;
      this.toastr.success('PDPM score calculated successfully', '', { timeOut: 2000 });
    }, 1000);
  }

  resetForm(): void {
    this.pdpmForm.reset();
    this.calculatedScore = null;
  }

  closeDialog(): void {
    this.dialogRef.close(this.calculatedScore);
  }
}
